import React, { useCallback, useState } from 'react'
import classNames from 'classnames'
import { Modal, ShareButtons, gaEvent } from 'shared'
import { ModalContentProps, SharingGridButtonProps } from './types'

export const SharingGridButton = ({
  shareUrl,
  gaLabel,
  platforms,
  modalHeader,
  buttonLabel,
  size,
  block,
  variant = 'outline',
}: SharingGridButtonProps) => {
  const [show, setShow] = useState(false)

  const handleClick = useCallback(() => {
    gaEvent('engagement', 'click sharing_modal_open')
    setShow(true)
  }, [])

  const onHide = useCallback(() => {
    gaEvent('engagement', 'click sharing_modal_close')
    setShow(false)
  }, [])

  const classes = classNames(
    'btn',
    variant === 'outline' && 'btn-outline-green',
    variant === 'primary' && 'btn-primary',
    size === 'large' && 'btn-large',
    size === 'huge' && 'btn-huge',
    block && 'btn-block'
  )

  return (
    <>
      <button onClick={handleClick} className={classes}>
        {buttonLabel}
      </button>

      <Modal
        id="sharing-grid"
        show={show}
        onHide={onHide}
        content={<ModalContent shareUrl={shareUrl} gaLabel={gaLabel} platforms={platforms} />}
        header={modalHeader}
      />
    </>
  )
}

const ModalContent = ({ shareUrl, gaLabel, platforms }: ModalContentProps): JSX.Element => (
  <>
    <p>{i18n.t('projects.show.stats.share_modal_text')}</p>
    <ShareButtons
      project
      platforms={platforms}
      mobileOnly={['whatsapp', 'messenger']}
      shape="roundWithLabel"
      shareUrl={shareUrl}
      withLabel
      gaCategory="engagement" // TODO: gaCategory is unused in ShareButtons
      gaLabel={gaLabel}
      asGrid
    />
  </>
)
